<template>
  <div>
    <template v-for="element in layerGroup">
      <layer-entry v-if="element.type === 'layer'" :layerId="element.id" :key="element.id"/>
      <layer-entry-rastless v-else-if="element.type === 'layer_rastless'" :layerId="element.id" :key="element.id"/>
      <layer-entry-dynamic-bands v-else-if="element.type === 'layer_dynamic_bands'" :layerId="element.id" :key="element.id"/>
      <geojson-entry v-else-if="element.type === 'layer_geojson'" :layerId="element.id" :key="element.id"/>
      <v-list-group v-else :sub-group="element.type === 'subcategory'" no-action>
        <template v-slot:activator>
          <v-list-item-title v-text="element.name"/>
        </template>
        <layer-group :layer-group="element.content"/>
      </v-list-group>
    </template>
  </div>
</template>

<script>
import layerEntry from "./layerEntry";
import geojsonEntry from "./geojsonEntry";
import GeojsonEntry from "./geojsonEntry";
import layerEntryRastless from "./layerEntryRastless";
import LayerEntryDynamicBands from "./LayerEntryDynamicBands";

export default {
  name: "layerGroup",
  props: ["layerGroup", "geojsonEntry"],
  components: {
    LayerEntryDynamicBands,
    GeojsonEntry,
    layerEntry,
    layerEntryRastless,
  }
}
</script>

<style scoped>
</style>